<template>
    <ResizableLayout
      left_content_class='contacts-list'
      :right_content_class="(contacts_selection.count > 0 || show_dashboard[route.name]) && !form_overlay[route.name] ? 'list-dashboard' : 'contacts-open'"
    >
        <template #left-content>
          <ContactsListSection
            @errorRetry="onLoadError()"
            :contacts_selection="contacts_selection"
            :contacts_view="contacts_view"
            :webmail_view="webmail_view"
          />

          <div class="contacts-overlay" v-if="form_overlay[route.name]"/>
        </template>

        <template #right-content>
            <ContactsDashboardSection v-if="(contacts_selection.count > 0 || show_dashboard[route.name]) && !form_overlay[route.name]"
              :contacts_selection="contacts_selection"
              :contacts_view="contacts_view"
              :webmail_view="webmail_view"
            />

            <router-view v-else
              @errorRetry="onLoadError()"
              :key="route.params.contact_id"
              :contacts_view="contacts_view"
            />
        </template>
    </ResizableLayout>

    <ContactsDeleteModal v-if="delete_modal_visibility"
      :contacts_selection='contacts_context'
      :broadcast_message="broadcast_message_delete"
      @deleteCancel='onDeleteSubmit()'
      @deleteSuccess="onDeleteSubmit()"
    />

    <ContactsSelectedToGroupModal v-if="selected_to_group_modal_visibility"
      :contacts_selection="contacts_context"
      @contactsToGroupCancel='onContactsSelectedToGroupCancel'
      @contactsToGroupSubmit='onContactsSelectedToGroupSubmit'
    />

    <ContactsToGroupModal v-if="contacts_to_group_modal_visibility"
      :group_selected="contacts_context"
      @contactsToGroupCancel='onContactsToGroupCancel'
      @contactsToGroupSubmit='onContactsToGroupSubmit'
    />
</template>

<script setup>
  import {reactive, ref}              from 'vue';
  import {onBeforeMount, onUnmounted} from 'vue';
  import {defineProps}                from 'vue';
  import {useRoute, useRouter}        from 'vue-router';
  import ContactsListSection          from './Sections/ContactsListSection.vue';
  import ContactsDashboardSection     from './Sections/ContactsDashboardSection.vue';
  import ContactsDeleteModal          from './Modals/ContactsDeleteModal.vue';
  import ContactsSelectedToGroupModal from './Modals/ContactsSelectedToGroupModal.vue';
  import ContactsToGroupModal         from './Modals/ContactsToGroupModal.vue';
  import ResizableLayout              from '@/vue/Layouts/ResizableLayout.vue';
  import ContactsSelectionCollection  from '@/js/Contacts/Collections/ContactsSelectionCollection';
  import MetadataController           from '@/js/Webmail/MetadataController';
  import ContactsController           from '@/js/Contacts/ContactsController';
  import StateConsumer                from '@/js/Shared/State/StateConsumer';

  const props = defineProps({
    webmail_view : {
      required: true,
    }
  })

  const contacts_controller                = ContactsController;
  const contacts_selection                 = reactive(new ContactsSelectionCollection());
  const contacts_context                   = ref([]);
  const broadcast_message_delete           = ref();
  const route                              = useRoute();
  const router                             = useRouter();
  const selected_to_group_modal_visibility = ref();
  const contacts_to_group_modal_visibility = ref();
  const delete_modal_visibility            = ref();
  const show_dashboard                     = {
    'contacts-list'       : true,
  }

  const form_overlay = {
    'contacts-person-add' : true,
    'contacts-person-edit': true,
    'contacts-group-add'  : true,
    'contacts-group-edit' : true,
  }

  onBeforeMount(async () => {
    MetadataController.setPageTitle('contacts.title');
    contacts_controller.broadcaster.on('contacts-deleted', onContactsDeleted);
    await fetchContacts();
  })

  onUnmounted(async () => {
    contacts_controller.broadcaster.destroy('contacts-deleted', onContactsDeleted);
  })

  const onLoadError = async () => {
    await fetchContacts();
  }

  const onDeleteSubmit = () => {
    closeContactsDelete();
  }

  const onContactsToGroupCancel = () => {
    closeContactsToGroup();
  }

  const onContactsToGroupSubmit = () => {
    closeContactsToGroup();
  }

  const onContactsSelectedToGroupCancel = () => {
    closeContactsSelectedToGroup();
  }

  const onContactsSelectedToGroupSubmit = () => {
    closeContactsSelectedToGroup();
  }

  const onActionAddFilter = () => {
    StateConsumer.set('filters_conditions_recipients', contacts_selection.emails_selected.items);
    router.push('/settings/filters/add');
  }

  const onActionToSendMail = (recipients) => {
    StateConsumer.set('contacts_to_recipients', recipients);
    router.push('/compose');
  }

  const onContactsDeleted = (contact_ids) => {
    if(contact_ids.includes(route.params.contact_id)){
      router.push('/contacts');
    }
  }

  const openContactsDelete = (context, broadcast_message) => {
    contacts_context.value         = context;
    broadcast_message_delete.value = broadcast_message;
    delete_modal_visibility.value  = true;
  }

  const closeContactsDelete = () => {
    delete_modal_visibility.value = false;
  }

  const openContactsSelectedToGroup = (context) => {
    contacts_context.value                   = context;
    selected_to_group_modal_visibility.value = true;
  }

  const closeContactsSelectedToGroup = () => {
    selected_to_group_modal_visibility.value = false;
  }

  const openContactsToGroup = (context) => {
    contacts_context.value                   = context;
    contacts_to_group_modal_visibility.value = true;
  }

  const closeContactsToGroup = () => {
    contacts_to_group_modal_visibility.value = false;
  }

  const fetchContacts = async () => {
    await contacts_controller.fetchContactsOnce();
  }



  const contacts_view = {
    openContactsDelete           : openContactsDelete,
    closeContactsDelete          : closeContactsDelete,
    openContactsSelectedToGroup  : openContactsSelectedToGroup,
    closeContactsSelectedToGroup : closeContactsSelectedToGroup,
    openContactsToGroup          : openContactsToGroup,
    closeContactsToGroup         : closeContactsToGroup,
    onActionAddFilter            : onActionAddFilter,
    onActionToSendMail           : onActionToSendMail,
  };
</script>